var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('trend-related-chart',{ref:"chart",attrs:{"data-config":_vm.data,"unit-prop":_vm.unitProp,"chart-height":_vm.chartHeight,"download-name":_vm.downloadName,"related-chart-width":_vm.relatedChartWidth,"scale":true}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-afe57944","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/04Statistical-Analysis/00PM/06Dust-Haze/DustHazeChartGroup.vue
// module id = null
// module chunks = 